export { LoyaltyHomeBody } from './LoyaltyHomeBody';
